import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash';
import { LodashService } from './lodash.service';
import * as io from 'socket.io-client';
import { EfoEgiService } from './egi.service';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EfoSdbService {
  //private url = 'http://socket1.carbrewer.com:3002';
  private socketUrl = 'http://socket.epiphanex.com:5000';
  private socket;

  private elevationUrl = environment.nestElevationApiUrl;

  constructor(
    private efoLd: LodashService,
    private efoEgi: EfoEgiService,
    private http: HttpClient, // private errorHandlerService: ErrorHandlerService
  ) {}

  getCampaignTables(): Observable<any> {
    return this.efoEgi.getData('/sdb/campaigns', {});
  }

  getAccountStats(): Observable<any> {
    return this.efoEgi.getData('/sdb/getAccountStats', {});
  }
  activeCampaignsRemote(): Observable<any> {
    return this.efoEgi.getData('/sdb/getActiveCampaignsRemote', {});
  }
  activeCampaigns(options?): Observable<any> {
    options = _.isUndefined(options) ? {} : options;
    return this.efoEgi.getData('/sdb/activeCampaigns', options).pipe(
      map((rs) => {
        _.each(rs, (d) => {
          d.website_short = _.isNull(d.website)
            ? ''
            : _.tail(d.website.split('.')).join('.');
        });
        return _.sortBy(rs, 'account_name');
      }),
    );
  }

  lookupsByType: any = {};
  lookups: any = [];
  getTypeLookups(reload_flag?: boolean): Observable<any> {
    reload_flag = _.isUndefined(reload_flag) ? false : reload_flag;
    if (!_.isEmpty(this.lookups) && !reload_flag) {
      return of(this.lookups).pipe();
    } else {
      return this.http.post(`${this.elevationUrl}/sdb/typeLookups`, {}).pipe(
        map((rs) => {
          this.lookups = rs;
          this.lookupsByType = _.reduce(
            rs,
            function (o, d, k) {
              let kk = k != 'dms' ? k + '_type_key' : k + 'type_key';
              o[k] = _.keyBy(d, kk);
              return o;
            },
            {},
          );
          return this.lookupsByType;
        }),
      );
    }
  }

  getConsumersByZipLimitOffset(zip, limit, offset): Observable<any> {
    return this.efoEgi.getData('/sdb/getConsumersByZipLimitOffset', {
      zip,
      limit,
      offset,
    });
  }
  getConsumerInformation(eui, zip): Observable<any> {
    return this.efoEgi.getData('/sdb/getConsumerInformation', {
      eui,
      zip,
    });
  }
  getMarketingCheckData(campaign_key): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/sdb/getMarketingCheckData`,
      {
        campaign_key,
      },
    );
  }
  getStatusInformation(statuses_key): Observable<any> {
    return this.efoEgi.getData('/sdb/getStatusInformation', {
      statuses_key,
    });
  }
  getConsumersByZip(options): Observable<any> {
    return this.efoEgi.getData('/sdb/getConsumersByZip', options);
  }
  getMatchesListByCampaign(options): Observable<any> {
    return this.efoEgi.getData('/sdb/getMatchesListByCampaign', options);
  }
  getRobomailDeliverabilityByCampaign(vipcode): Observable<any> {
    //return of([]);
    return this.efoEgi.getData('/sdb/getRobomailDeliverabilityByCampaign', {
      vipcode,
    });
  }
  targetRefreshesByCampaignKey(options): Observable<any> {
    return this.efoEgi.getData('/sdb/targetRefreshesByCampaignKey', options);
  }
  getTargetListByCampaign(options): Observable<any> {
    return this.efoEgi.getData('/sdb/getTargetListByCampaign', options);
  }
  campaigns(options): Observable<any> {
    return this.efoEgi.getData('/sdb/campaigns', options);
  }
  accountCampaigns(account_num): Observable<any> {
    return this.efoEgi.getData('/sdb/accountCampaigns', {
      account_num,
    });
  }
  typeLookups(options): Observable<any> {
    return this.http.post(`${this.elevationUrl}/sdb/typeLookups`, options);
  }
  //These two are sent to the SDB server

  syncZips(zips): Observable<any> {
    return this.efoEgi.getData('/sdb/getData', {
      url: '/sdb/batchZipExport',
      zips: zips,
    });
  }
  batchMatchingExport(campaigns): Observable<any> {
    return this.efoEgi.getData('/sdb/getData', {
      url: '/sdb/batchMatchingExport',
      campaigns,
    });
  }

  robomailDeliverability(): Observable<any> {
    return this.efoEgi.getData('/sdb/robomailDeliverability', {});
  }

  getJsonFile(filename): Observable<any> {
    return this.efoEgi.getData('/sdb/getJsonFile?v=' + moment().unix(), {
      filename,
    });
  }
  saveTargetAudienceData(account_num): Observable<any> {
    return this.http.get(
      `${environment.nestEflowApiUrl}/dms/setAudienceAnalysisData?account_num=${account_num}`,
    );
  }
  getTargetAudienceData(account_num): Observable<any> {
    return this.efoEgi
      .getData('/sdb/getJsonFile', {
        filename: 'target-audience-data/' + account_num + '.json',
      })
      .pipe(
        map((rs) => {
          var numCols = [
            'd_rank',
            'sp_rank',
            'rp_rank',
            'mp_rank',
            'sc_rank',
            'rc_rank',
            'mc_rank',
            'population',
            'distance',
            'sales_cnt',
            'service_cnt',
            'marketing_cnt',
            'sales_perc',
            'service_perc',
            'marketing_perc',
            'sales_perc_pop',
            'service_perc_pop',
            'marketing_perc_pop',
            'rt_sales_distance',
            'rt_service_distance',
            'rt_sales_perc_pop',
            'rt_service_perc_pop',
            'rt_sales_perc',
            'rt_service_perc',
          ];
          _.each(rs.data, (d) => {
            _.each(numCols, (k) => {
              d[k] = this.efoLd.isNumeric(d[k]) ? +d[k] : d[k];
            });
          });
          return rs;
        }),
      );
  }
  getTargetAudienceDataNew(account_num): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/sdb/targetAudienceData`,
      {
        account_num,
      },
    );
  }
  processYpFiles(zips): Observable<any> {
    return this.efoEgi.getData('/sdb/processYpFiles', { zips: zips });
  }
  updateZipCnts(zips): Observable<any> {
    return this.efoEgi.getData('/sdb/updateZipCnts', { zips: zips });
  }
  moveYpToMarketing(
    account_num,
    campaign_key,
    zips: String[],
    limit,
  ): Observable<any> {
    limit = _.isUndefined(limit) ? 12000 - 500 + _.random(0, 1000) : limit;
    return this.efoEgi.getData('/sdb/moveYpToMarketing', {
      account_num,
      campaign_key,
      zip: zips.join(','),
      limit,
    });
  }
  getYpMarketingCount(
    account_num,
    campaign_key,
    zips: String[],
  ): Observable<any> {
    return this.efoEgi.getData('/sdb/getYpMarketingCount', {
      account_num,
      campaign_key,
      zip: zips.join(','),
    });
  }
  movePreexistingToMarketing(
    account_num,
    campaign_key,
    zips: String[],
    limit,
  ): Observable<any> {
    limit = _.isUndefined(limit) ? 12000 - 500 + _.random(0, 1000) : limit;
    return this.efoEgi.getData('/sdb/movePreexistingToMarketing', {
      account_num,
      campaign_key,
      zip: zips.join(','),
      limit,
    });
  }
  getPreexistingCount(
    account_num,
    campaign_key,
    zips: String[],
  ): Observable<any> {
    return this.efoEgi.getData('/sdb/getPreexistingCount', {
      account_num,
      campaign_key,
      zip: zips.join(','),
    });
  }
  getAccountPerformanceChartSales(account_num): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/sdb/getAccountPerformanceChartSales`,
      {
        account_num,
      },
    );
  }
  getAccountPerformanceChartService(account_num): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/sdb/getAccountPerformanceChartService`,
      {
        account_num,
      },
    );
  }

  refreshAccountStats(account_num): Observable<any> {
    return this.efoEgi.getData('/sdb/refreshAccountStats', {
      acct_num: account_num,
    });
  }
  refreshAllAccountStats(): Observable<any> {
    return this.efoEgi.getData('/sdb/refreshAccountStats', {});
  }
  //Main Daily Matching trigger starts sync and batch matching.
  triggerDailyMatching(): Observable<any> {
    return this.efoEgi.getData('/sdb/syncEgiActiveCampaigns', {});
  }
  triggerBatchMatching(): Observable<any> {
    return this.efoEgi.getData('/sdb/batchMatching', {});
  }
  deleteAccount(account_num): Observable<any> {
    return this.efoEgi.getData('/sdb/deleteAccount', {
      account_num,
    });
  }
  public socketListen = () => {
    if (_.isUndefined(this.socket)) {
      this.socket = io(this.socketUrl, {
        transports: ['websocket'],
      });
      this.socket.on('connect', () => {
        this.socket.emit(
          'new-message',
          'portal service connected: sbd.service',
        );
      });
    }
    return new Observable((observer) => {
      this.socket.on('sdb', (data) => {
        observer.next(data);
      });
    });
  };
}
